module.exports = __webpack_public_path__ + "dbe58c149822f7d403fd3d3fa1549b06.MP3";